import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useContext } from "react";
import AuthContext from "../context/AuthContext";

const PrivateRoutes = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  return user ? (
    <Outlet />
  ) : (
    <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />
  );
};

export default PrivateRoutes;
